/**
 * @generated SignedSource<<54c77eafe8a6a58b560b1beba829c986>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ResumeStatusEnum = "processed" | "processing" | "processing_failed" | "processing_queued" | "unprocessed";
import { FragmentRefs } from "relay-runtime";
export type resume_useIsImportingResume$data = {
  readonly copyToProfile: boolean | null | undefined;
  readonly id: string;
  readonly importTimeoutAt: string | null | undefined;
  readonly status: ResumeStatusEnum | null | undefined;
  readonly user: {
    readonly id: string;
  } | null | undefined;
  readonly " $fragmentType": "resume_useIsImportingResume";
};
export type resume_useIsImportingResume$key = {
  readonly " $data"?: resume_useIsImportingResume$data;
  readonly " $fragmentSpreads": FragmentRefs<"resume_useIsImportingResume">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "resume_useIsImportingResume",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "importTimeoutAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "copyToProfile",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Resume",
  "abstractKey": null
};
})();

(node as any).hash = "9d4e4c3092b08536ea0da86771010317";

export default node;
